export default __webpack_public_path__ + "static/media/response.eb5ab88d.svg";